import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M8.279 12.342 5.7 12.3a13.483 13.483 0 0 1-2.5-.159c-1.247-.255-1.335-1.5-1.428-2.552a17.882 17.882 0 0 1 .163-4.433 1.514 1.514 0 0 1 1.5-1.362 82.445 82.445 0 0 1 8.377-.08 6.074 6.074 0 0 1 .879.1c1.43.251 1.465 1.667 1.557 2.858a16.151 16.151 0 0 1-.123 3.61c-.142.99-.413 1.82-1.557 1.9-1.435.105-2.836.19-4.274.163-.003-.003-.011-.003-.015-.003ZM6.761 9.836c1.08-.621 2.14-1.231 3.215-1.847-1.083-.621-2.141-1.231-3.215-1.847Z';
const draw24px =
  'M12.41,18.39l-3.8-.07a19.57,19.57,0,0,1-3.67-.23c-1.84-.37-2-2.21-2.1-3.75a26,26,0,0,1,.24-6.53,2.23,2.23,0,0,1,2.2-2c4.1-.28,8.23-.25,12.32-.12a8.1,8.1,0,0,1,1.3.16c2.1.36,2.15,2.45,2.29,4.2A23.59,23.59,0,0,1,21,15.36c-.21,1.46-.61,2.68-2.29,2.8-2.11.16-4.18.28-6.29.24ZM10.18,14.7,14.91,12,10.18,9.27Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const LogoYouTubeIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'logoYouTube'),
) as IconWithRender;

LogoYouTubeIcon.displayName = 'LogoYouTubeIcon';
LogoYouTubeIcon.propTypes = Icon.propTypes;
LogoYouTubeIcon.renderIcon = (props) => <LogoYouTubeIcon {...props} />;
export default LogoYouTubeIcon;
